import type { FooterContent } from "../types/content";

export const footerContent: FooterContent = {
  company: {
    name: "Stochastic ApS",
    address: "Kuhlausgade 7, 2100 Copenhagen",
    cvr: "CVR 40786279",
  },
  contact: {
    phone: "+45 53667951",
    email: "graeme.keith@stochastic.dk",
  },
};
